import { useEffect, useState } from "react"

const StudyCard = ({
  study,
  backgroundImage,
  onClick,
  actionButtons = null,
  variant = "cro", // 'cro', 'investigator', or 'closed'
  className = "",
  
}) => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0)

  useEffect(() => {
    if (typeof window === "undefined") return

    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const getCardSize = () => {
    if (windowWidth >= 1920) return 320
    if (windowWidth >= 1440) return 280
    if (windowWidth >= 1024) return 240
    if (windowWidth >= 768) return 200
    if (windowWidth >= 640) return 180
    if (windowWidth >= 480) return 160
    return 240
  }

  const cardSize = getCardSize()
  const isSmallScreen = windowWidth < 768 

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    const date = new Date(dateString)
    return new Intl.DateTimeFormat("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date)
  }

  const showAllInfo = cardSize >= 240 && !isSmallScreen
  const showModifiedDate = cardSize >= 200 && !isSmallScreen

  return (
    <div
  className={`overflow-hidden border-2 border-[#5B93FF] cursor-pointer hover:shadow-lg transition-shadow  rounded-2xl ${className}`}
  style={{
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    aspectRatio: "1 / 1",
    width: "100% ",
    boxShadow: "inset 0px 0px 30px rgba(0, 0, 0, 0.3)"
  }}
  onClick={onClick}
>

      <div className="text-white p-3 h-full flex flex-col">
      <div
  className="overflow-y-auto custom-scroll flex-grow"
  style={{
    maxHeight: "calc(100% - 40px)",
    minHeight: 0,
  }}
>

<h3 className="text-lg sm:text-xl md:text-xl  text-center font-bold  mb-2">{study.name}</h3>


          {!isSmallScreen && (
            <div className="space-y-1">
            <div className="text-xs sm:text-sm md:text-base mt-6">
              <span className="font-extrabold ">Created by: </span>
              <span>{study.createdBy || "IQVIA"}</span>
            </div>

            {variant === "cro" && (
              <div className="space-y-1">
                <div className="text-xs sm:text-sm md:text-base">
                  <span className="font-extrabold ">Creation date: </span>
                  <span>{formatDate(study.createdAt)}</span>
                </div>
                {showModifiedDate && study.updatedAt && (
                  <div className="text-xs sm:text-sm md:text-base">
                    <span className="font-extrabold ">Last modified: </span>
                    <span>{formatDate(study.updatedAt)}</span>
                  </div>
                )}
                {showAllInfo && study.lastTraceability && (
                  <div className="text-xs sm:text-sm md:text-base">
                    <span className="font-extrabold ">Last traceability: </span>
                    <span>{formatDate(study.lastTraceability)}</span>
                  </div>
                )}
              </div>
            )}

            {variant === "closed" && (
              <div className="space-y-1">
                <div className="text-xs sm:text-sm md:text-base">
                  <span className="font-extrabold">Creation date: </span>
                  <span>{formatDate(study.createdAt)}</span>
                </div>
                {showModifiedDate && study.completedAt && (
                  <div className="text-xs sm:text-sm md:text-base">
                    <span className="font-extrabold">Closing date: </span>
                    <span>{formatDate(study.completedAt)}</span>
                  </div>
                )}
                {showModifiedDate && study.updatedAt && (
                  <div className="text-xs sm:text-sm md:text-base">
                    <span className="font-extrabold">Last modified: </span>
                    <span>{formatDate(study.updatedAt)}</span>
                  </div>
                )}
                {showAllInfo && study.last_traceability && (
                  <div className="text-xs sm:text-sm md:text-base">
                    <span className="font-extrabold">Last traceability: </span>
                    <span>{formatDate(study.last_traceability)}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

        {actionButtons && !isSmallScreen && (
          <div className="mt-auto w-full pt-2 px-1"> {actionButtons(study)}</div>
        )}
      </div>
    </div>
  )
}

export default StudyCard